import { Routes, Route } from "react-router-dom";
import CameraPage from "./CameraPage.jsx";
import UploadedImages from "./components/UploadedImages";
import UploadsMenu from "./components/UploadsMenu";

function App() {
  return (
    <Routes>
      {/* <Route path="/" element={<CameraPage />} />
      <Route path="/uploads" element={<UploadedImages />} /> */}
      <Route path="/" element={<UploadsMenu />} />
      <Route
        path="/app-uploads"
        element={<UploadedImages apiPrefix="/app" source="app" />}
      />
      <Route
        path="/web-uploads"
        element={<UploadedImages apiPrefix="/app" source="web" />}
      />
    </Routes>
  );
}

export default App;
